let self

export const state = {}

export const getters = {}

export const mutations = {
  SET_MAP(state, newMap) {
    self = newMap
  },
}

export const actions = {
  updateMap({ commit }, newMap) {
    commit('SET_MAP', newMap)
  },
  centerOnAddress({ state }, { address, shouldZoom = false }) {
    if (!self) return

    setTimeout(() => {
      self.flyTo({
        center: [address.longitude, address.latitude],
        zoom: shouldZoom ? Math.max(14, self.getZoom()) : self.getZoom(),
        curve: shouldZoom ? 1.42 : 1,
      })
    }, 1)
  },
  resize() {
    if (!self) return

    setTimeout(() => {
      self.resize()
    }, 1)
  },
}
